module.exports = {
  label: {
    startDate: 'Start Date',
    endDate: 'End Date',
    noScriptPaid: 'No. of script paid',
    lastPaymentDate: 'Last Payment Date',
    paymentStatus: 'Payment Status',
    openingBalance: 'Opening Balance',
    closingBalance: 'Closing Balance',
    filter: 'Filter',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    paymentsFrompatients: 'Payments from patients',
    paymentsFromAdmin: 'Payments from Admin',
    scriptId: 'Script ID',
    dateTime: 'Date & Time',
    date: 'Date',
    noDataFound: "No Data Found",
    selectEndDate: "Please select end date",
    selectStartDate: "Please select start date",
    selectDates: "Please select dates",
    patientName: 'Name of Patient',
    totalAmount: 'Total Amount',
    myAmount: 'My Amount',
    paymentMode: "Payment Mode",
    adminCommission: 'Admin’s Commission',
    placeholder: {
      date: "DD/MM/YY"
    },
    buttons: {
      filter: 'Filter',
      reset: 'Reset'
    }
  }
}